import http from "@/utils/http";
// 获取首页配置信息
export const getHomeData = () => http.get('/nonlogin/mobile/queryVisible.htm');
// 获取轮播图/机器人/未读数
export const getBanner = () => http.get('/nonlogin/mobile/home/data.htm');
// 查询服务对象列表(包含推荐服务)
export const getHotService = () => http.get('/nonlogin/mobile/serviceObject/queryMobileServiceObjectList.htm');
// 查询专题列表
export const getThematicService = (params) => http.get('/nonlogin/onewebsitehande/queryAllSpeciaList.htm', params);
// 查询专题分类
export const querySpeciaType = () => http.get('/nonlogin/specia/querySpeciaTypeByPage.htm');
// 查询专题更多页
export const querySpeciaMore = (params) => http.get('/nonlogin/mobile/onewebsitehande/queryMobileSpecialMoreData.htm',params);
//查询专题栏目详情
export const querySpeciaService = (params) => http.get('/nonlogin/mobile/onewebsitehande/queryMobileSpeciaServiceData.htm',params);
// 查询直通部门
export const getDepartment = () => http.get('/nonlogin/serviceHandleCenter/queryDirectDeptList.htm');
// 查询服务资讯（首页）
export const queryServiceNews = (params) => http.get('/nonlogin/onewebsitehande/queryAfficheList.htm',params);
//查询服务资讯(列表页)
export const queryServiceNewsForUser = (params) => http.get('/nonlogin/affiche/mobile/queryAfficheListForUser.htm',params);
//查询服务资讯详情页
export const queryServiceNewsDetail = (afficheId) => http.get('/nonlogin/mobile/affiche/mobileAfficheDetailForUser.htm',{afficheId:afficheId});
//关注部门
export const queryFocusOrg = (params) => http.get('/affiche/mobile/saveAttentionOrg.htm', params);
//取关部门
export const queryCancelFocusOrg = (orgId) => http.get('/affiche/mobile/cancelAttentionOrg.htm',{orgId:orgId});
//查询服务资讯类型
export const queryServiceTypes = () => http.get('/nonlogin/affiche/publishorg/listtag.htm');
//查询服务资讯部门
export const queryServiceDepts = () => http.get('/nonlogin/affiche/publishorg/listmore.htm');
// 搜索页获取热词
export const getHotWord = () => http.get('/nonlogin/onewebsitehande/queryHotWordList.htm');
// 高频办理事项
export const getHighService = () => http.get('/nonlogin/visitor/getServicesByTarget.htm');
// 查询消息
export const queryMessage = (pageIndex, keyword) => http.get('getMessageList', {
    pageIndex: pageIndex,
    pageSize: 20,
    key: keyword,
    source: 'system',
    hasReadDetail: "1"
})


// 查询指定人消息
export const queryInteractions = (pageIndex, uid) => http.get('getInteractions', {
    pageIndex: pageIndex,
    pageSize: 20,
    tid: uid,
})

export const queryMessageDetail = (data) => http.post('getMessageList', data)
// 查询未读消息
export const getUnreadMessageCount = () => http.get('/nonlogin/sm/message/getUnreadMessageCount.htm')
// 查询便民服务
export const queryConvenienceService = () => http.get('nonlogin/onewebsitehande/queryConvenienceService.htm')
// 查询业务直通车
export const getExpress = (bizType) => http.get(`busexpress/card/queryExpressCardData.htm?bizType=${bizType}`)

//查询当前用户订阅信息
export const getNews = () => http.get('portalNews/query.htm')
// 查询订阅信息
export const getAllNews = () => http.get('portalNews/all.htm')
//查询某个信息下的详细信息
export const queryTitleOfNews = (params) => http.get(`/portalnews/query/rss.htm`,{key:params});
//删除当前用户订阅信息
export const delNews = (params) => http.post(`portalNews/remove.htm`,{newKey:params});
//修改当前用户订阅信息
export const modifyNews = (params) => http.post(`portalNews/add.htm`,params);
//查询当前用户是否为已读状态
export const queryReadStatus = (params) => http.post(`sm/message/readMessageDetail.htm`,params);
/**
 * 根据uuid查询用户信息，uuid为空时查询当前登录用户信息
 * @param uuid
 * @returns {*}
 */
export const queryUserInfo = (uuid) => http.get('api/getUserAttributeForMobile.htm', {id: uuid})



